import { DialogSchema, StepSchema } from '@feedyou/schema'

export const extractStepsFromDialogs = (dialogs: DialogSchema[]): StepSchema[] => {
  return dialogs.reduce((steps, currentDialog) => {
    steps.push(...currentDialog.steps)
    return steps
  }, [] as StepSchema[])
}
